import { getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { apiConfig } from "../config/apiConfig";
import { REGEX } from "../constants/regex";
import { handleGetFallbackLocationData } from "./share";

export const NO_CITY_FOUND = 'no city found';
export const NO_STATE_FOUND = 'no state found';
let position = {
    lat: 0,
    lng: 0
};

// Private variables
let _allAddressList: any[] = [];
let _address1Details = '';
let _suggestedAddress: any = [];

// Getters
export function getAllAddressList(): any[] {
    return _allAddressList;
}

export function getAddress1Details(): string {
    return _address1Details;
}

export function getSuggestedAddress(): any {
    return _suggestedAddress;
}

// Setters
export function setAllAddressList(value: any[]): void {
    _allAddressList = value;
}

export function setAddress1Details(value: string): void {
    _address1Details = value;
}

export function setSuggestedAddress(value: any[]): void {
    _suggestedAddress = value;
}
export function isValidZip(zipcode:string) : boolean{
    const zipRegex = REGEX.sendZip;
    if(zipcode && zipcode != '00000' && zipRegex.test(zipcode)){
        return true;
    }
    else{
        return false;
    }
}
export async function discoverSuggestions(zipCodeElem:any, AddrElem:any) : Promise<any>{
    let isFlag = false;
    if (isValidZip(zipCodeElem?.value.trim()) && zipCodeElem.id.includes('zip-code')) {
        isFlag = true;
    }
    return new Promise((resolve, reject) => {
        if(isFlag){
            const latLngRequest = `${apiConfig.geoCodeSearchApiUrl}?qq=postalCode=${zipCodeElem.value}&apiKey=${process.env.JS_Heremap_API_KEY}&in=countryCode%3AUSA%2CCAN%2CPRI`;
            getCachedAPIResponse(latLngRequest)
            .then((response: any) => {
                position = response?.items[0].position;
                if(AddrElem.value){
                    let endpoint = `${apiConfig.DISCOVER_API}?q=${AddrElem.value}&in=countryCode%3AUSA%2CCAN%2CPRI&in=circle:${position.lat},${position.lng};r=50000&apiKey=${process.env.JS_Heremap_API_KEY}`;
                    getCachedAPIResponse(endpoint)
                    .then((result:any)=>{
                        let resultData: any = [];
                        result?.items.forEach((item:any)=>{
                            if(item.address.postalCode?.includes('-')){
                                item.address.postalCode = item.address.postalCode.split('-')[0];
                                let label = item.address.label.split(item.address.postalCode);
                                if(label.length>1){
                                    label = label[0] + item.address.postalCode + "," + label[1].split(",")[1];
                                }
                                item.address.label = label;
                            }
                            if(item.address.postalCode === zipCodeElem.value){
                                resultData.push(item);
                            }
                        }); 
                        if(resultData.length > 0) {
                            setSuggestedAddress(resultData[0]);
                            setAllAddressList(resultData);
                            AddrElem.setAttribute("data-suggestion", JSON.stringify(getAllAddressList()[0]));
                            setDatat(getAllAddressList(), AddrElem);
                            resolve(true);
                        }
                        else{
                            resolve(true);
                        }
                    })
                    .catch((err:any)=>{
                        console.error("Error fetching suggestions:", err);
                        resolve([]);
                    });
                }
                
            })
            .catch((err: any)=>{
                console.error("Error fetching suggestions:", err);
                resolve([]);
            });
        }
        else{
            discoveryAPI(AddrElem.value)
            .then((result:any) => {
                setSuggestedAddress(result?.items[0]);
                result?.items.forEach((item:any)=>{
                    if(item.address.postalCode?.includes('-')){
                        item.address.postalCode = item.address.postalCode.split('-')[0];
                        let label = item.address.label.split(item.address.postalCode);
                        if(label.length>1){
                            label = label[0] + item.address.postalCode + "," + label[1].split(",")[1];
                        }
                        item.address.label = label;
                    }
                }); 
                setAllAddressList(result?.items);
                AddrElem.setAttribute("data-suggestion", JSON.stringify(result.items[0]));
                setDatat(getAllAddressList(), AddrElem);
                resolve(true);
            }).catch((err:any) => {
                console.error("Error fetching suggestions:", err);
                resolve([]);
            });
        }
    });
    
}

export async function discoverSuggestionsFilter(zipCodeElem: any, AddrElem: any, searchString?: string): Promise<any> {
     // Early return if no address value
    if (!AddrElem?.value) {
        return [];
    }
    let isFlag = false;
    if (isValidZip(zipCodeElem?.value.trim()) && zipCodeElem.id.includes('zip-code')) {
        isFlag = true;
    }
    return new Promise((resolve, reject) => {
        if (isFlag) {
            const latLngRequest = `${apiConfig.geoCodeSearchApiUrl}?qq=postalCode=${zipCodeElem.value}&apiKey=${process.env.JS_Heremap_API_KEY}&in=countryCode%3AUSA%2CCAN%2CPRI`;
            getCachedAPIResponse(latLngRequest)
                .then((response: any) => {
                    position = response?.items[0].position;
                    if (AddrElem.value) {
                        //Tried the endpoint-gives us same result with filter let endpoint = `${apiConfig.geoCodeSearchApiUrl}?q=${AddrElem.value}&apiKey=${process.env.JS_Heremap_API_KEY}`;
                       let endpoint = `${apiConfig.DISCOVER_API}?q=${AddrElem.value}&in=countryCode%3AUSA%2CCAN%2CPRI&in=circle:${position.lat},${position.lng};r=50000&apiKey=${process.env.JS_Heremap_API_KEY}`;
                        getCachedAPIResponse(endpoint)
                            .then((result: any) => {
                                let resultData: any = [];
                                result?.items.forEach((item: any) => {
                                    const address = item.address;
                                      if (item.address.postalCode?.includes('-')) {
                                item.address.postalCode = item.address.postalCode.split('-')[0];
                                let label = item.address.label.split(item.address.postalCode);
                                if (label.length > 1) {
                                    label = label[0] + item.address.postalCode + "," + label[1].split(",")[1];
                                }
                                item.address.label = label;
                            }
                            if (item.address.postalCode === zipCodeElem.value &&
                                addressMatchesSearch(address,searchString)                                
                                    ) {
                                        resultData.push(item);
                                    }
                                });
                                if (resultData.length > 0) {
                                    setSuggestedAddress(resultData[0]);
                                    setAllAddressList(resultData);
                                    AddrElem.setAttribute("data-suggestion", JSON.stringify(getAllAddressList()[0]));
                                    setDatat(getAllAddressList(), AddrElem);
                                    resolve(resultData);
                                }
                                else {
                                    const suggestionContainer = document.querySelector('.suggestion-container');
                                    suggestionContainer?.remove();
                                    resolve([]);
                                }
                            })
                            .catch((err: any) => {
                                console.error("Error fetching suggestions:", err);
                                const suggestionContainer = document.querySelector('.suggestion-container');
                                suggestionContainer?.remove();
                                resolve([]);
                            });
                    }

                })
                .catch((err: any) => {
                    console.error("Error fetching suggestions:", err);
                    const suggestionContainer = document.querySelector('.suggestion-container');
                    suggestionContainer?.remove();
                    resolve([]);
                });
        }
        else {
            discoveryAPI(AddrElem.value)
                .then((result: any) => {
                    setSuggestedAddress(result?.items[0]);
                    let resultData: any[] = [];
                    result?.items.forEach((item: any) => {
                                if (item.address.postalCode?.includes('-')) {
                        item.address.postalCode = item.address.postalCode.split('-')[0];
                        let label = item.address.label.split(item.address.postalCode);
                        if (label.length > 1) {
                            label = label[0] + item.address.postalCode + "," + label[1].split(",")[1];
                        }
                        item.address.label = label;
                    }
                        const address = item.address;
                        if (
                            address.postalCode === zipCodeElem.value &&
                            addressMatchesSearch(address,searchString)
                        ) {
                            resultData.push(item);
                        }
                    });

                    setAllAddressList(result?.items);
                    AddrElem.setAttribute("data-suggestion", JSON.stringify(result.items[0]));
                    setDatat(getAllAddressList(), AddrElem);
                    resolve(resultData);
                }).catch((err: any) => {
                    console.error("Error fetching suggestions:", err);
                    const suggestionContainer = document.querySelector('.suggestion-container');
                    suggestionContainer?.remove();
                    resolve([]);
                });
        }
    });
    
}

export async function discoveryAPI(arg:string):Promise<any>{
    try{
        if(arg){
            const endpoint = `${apiConfig.DISCOVER_API}?q=${arg}&in=countryCode%3AUSA%2CCAN%2CPRI&at=0,0&apiKey=${process.env.JS_Heremap_API_KEY}`;
            const result = await getCachedAPIResponse(endpoint);
            return result;
        }
    }
    catch{
        throw new Error('Discover API does not return');
    }
    
}

export function setDatat(suggestions: any,AddrElem:any) {
    try {
        const inputElement = AddrElem;
        const suggestionContainer: any = document.createElement("ul") as HTMLElement;
        suggestionContainer.className = "suggestion-container";

        // Clear previous suggestions
        while (inputElement.nextSibling && inputElement.nextSibling.className === "suggestion-container") {
            inputElement.parentNode.removeChild(inputElement.nextSibling);
        }
        
        suggestions.forEach((matchingSuggestion: any) => {
            const suggestionItem = document.createElement("li");
            suggestionItem.className = "suggestion-item";
            suggestionItem.textContent = matchingSuggestion?.address.label;
            suggestionItem.setAttribute('data-heremap', JSON.stringify(matchingSuggestion.address) ?? '');

            suggestionItem.addEventListener("click", () => {
                sessionStorage.setItem("suggestion", "true");
                inputElement.value = matchingSuggestion.address.label;
                suggestionContainer.parentNode.removeChild(suggestionContainer);
                const heremapData = JSON.parse(suggestionItem.getAttribute('data-heremap') as string);
                const suggestedAddress = getAddressDetails(heremapData);
                sessionStorage.setItem('suggestedAddress',JSON.stringify(suggestedAddress));
                (inputElement as HTMLInputElement).focus()
                setAddress1Details(suggestedAddress);
            });

            suggestionContainer.appendChild(suggestionItem);
        });

        if (suggestions.length > 0) {
            inputElement.parentNode.insertBefore(suggestionContainer, inputElement.nextSibling);
        }

    } catch (error) {
        console.log("error", error)    
    }
}

export function replaceLast(str: string, search: string, replacement: string): string {
    const lastIndex = str.lastIndexOf(search);
    if (lastIndex === -1) return str;
    return str.slice(0, lastIndex) + replacement + str.slice(lastIndex + search.length);
}

export  function trimLabel(heremapData:any):string{
    const requiredKeyList = ['countryName','countryCode','postalCode','stateCode', 'city', 'county','district','street','houseNumber'];
    let flattenObj = heremapData.label.replace(/,/g, "");
    requiredKeyList.forEach((key)=>{
        if (heremapData.hasOwnProperty(key)) {
            flattenObj = replaceLast(flattenObj, heremapData[key], "");
        }
    });
    return flattenObj.trim();
}

export function setNAC(output:string):string{
    if(!output){
        return "No Address Collected";
    }
    return output;
}

export function getAddressDetails(heremapData:any):any{
    if(!heremapData || Object.keys(heremapData).length === 0){
        return {};
    }
    let label = trimLabel(heremapData);
    let output = "";
    if(label){
        output = label;
    }
    if(heremapData.hasOwnProperty('houseNumber')){
        if(output){
            output = `${output}, `;
        }
        output = `${output}${heremapData.houseNumber} `;
        
    }
    if(heremapData.hasOwnProperty('street')){
        if(output && output==label){
            output = output + ", ";
        }
        output = output + heremapData.street;
    }
    if(heremapData.hasOwnProperty('district') && heremapData.label.includes(heremapData.district)){
        if(output && output!=label){
            output = output + ",";
        }
        output = output + " " + heremapData.district;
    }
    const suggestedAddress = {
        "addr1": `${setNAC(output)}`,
        "city": `${isValid(heremapData.city)}`,
        "stateCode": `${isValid(heremapData.stateCode)}`,
        "postalCode": `${isValid(heremapData.postalCode)}`,
        "country": `${isValid(heremapData.countryCode)}`
    };
    return suggestedAddress;
}

export function isValid(arg:string){
    if(arg && arg!="null" && arg!="undefined"){
        return arg;
    }
    else{
        return '';
    }
}

type cityState = string | null | undefined;

export const invalidCityState = (city:cityState, state:cityState): boolean => {
    if (!city || !state || !city.trim() || !state.trim()) {
        return true;
    }
    if( city?.trim()?.toLowerCase() === NO_CITY_FOUND ) {
        return true;
    }
    if( state?.trim()?.toLowerCase() === NO_STATE_FOUND ) {
        return true;
    }
    return false;
}

export async function handleMissingData(city:cityState,state:cityState,zipCode:string | null | undefined): Promise<any>{
    const manualStateCode = sessionStorage.getItem("manualStateCode");
    if ((invalidCityState(city, state) || !manualStateCode?.trim()) && zipCode) {
        try {
            const result = await discoveryAPI(zipCode);
            const outputData = result?.items?.[0];
            const address = outputData?.address;
            sessionStorage.setItem("manualStateCode", address?.stateCode || "");
            if(address?.stateCode && address?.city) {
                state = address?.stateCode;
                city = address?.city;
            } else {
                const fallbackLocation = await handleGetFallbackLocationData();
                state = fallbackLocation.state;
                city = fallbackLocation.city;
            }
            city = city || NO_CITY_FOUND;
            state = state || NO_STATE_FOUND;
            sessionStorage.setItem("manualCity", city);
            sessionStorage.setItem("manualState", state);
            return Promise.resolve({ "city": city, "state": state });
        } catch (error) {
            console.warn("handleMissingData: Error occurred while fetching data from HERE Maps API", error);
            if(invalidCityState(city, state)) {
                const fallbackLocation = await handleGetFallbackLocationData();
                state = fallbackLocation.state;
                city = fallbackLocation.city;
            }
            city = city || NO_CITY_FOUND;
            state = state || NO_STATE_FOUND;
            sessionStorage.setItem("manualCity", city);
            sessionStorage.setItem("manualState", state);
            return Promise.resolve({ "city": city, "state": state });
        }
    } else {
        return Promise.resolve({ "city": city, "state": state });
    }
}

export function getAddressConfirmation(bookingData:any){
    if (!bookingData || (Object.keys(bookingData).length === 0)) {
    return { "line1": "", "line2": "" };
}
    const suggestFlag = sessionStorage.getItem("suggestion");
    const suggestAddr = sessionStorage.getItem("suggestedAddress") as string;
    let text1,text2;
    if(suggestFlag && suggestFlag === "true" && suggestAddr){                
        const suggestJSON = JSON.parse(suggestAddr);
        const addressParts1 = [
            suggestJSON?.addr1,
            bookingData?.Address2 ?? bookingData?.address2 ?? ''
        ];
        text1 = concatFirstLine(addressParts1); 
        const addressParts2 = [
            validInput(suggestJSON?.city,bookingData?.City ?? bookingData?.city),
            validInput(suggestJSON?.stateCode,bookingData?.State ?? bookingData?.state),
            bookingData?.PostalCode ?? bookingData?.postalCode
        ];
        text2 = concatSecondLine(addressParts2); 
    }
    else{
        const addressParts1 = [
            bookingData?.Address ?? bookingData?.address ?? '',
            bookingData?.Address2 ?? bookingData?.address2 ?? ''
        ];
        text1 = concatFirstLine(addressParts1);
        const addressParts2 = [
            bookingData?.City ?? bookingData?.city,
            bookingData?.State ?? bookingData?.state,
            bookingData?.PostalCode ?? bookingData?.postalCode
        ];
        text2 = concatSecondLine(addressParts2);
        
    }
    sessionStorage.setItem("suggestion","false"); 
    return {"line1": text1, "line2": text2};
}

export function validInput(input1:string,input2:string): string {
    if(input1 && input1!="" && input1!=null){
        return input1;
    }
    else{
        return input2;
    }
}

export function concatSecondLine(addressParts2:string[]): string {
    return addressParts2.filter((part:string) => part && part !== '' && part.toLowerCase() !== 'no city found' && part.toLowerCase() !== 'no state found')
        .join(', ');
}

export function concatFirstLine(addressParts2:string[]): string {
    return addressParts2
        .filter((part: string) => part && part !== '' && part !== 'No Address Collected')
        .join(', ');
}

export function addressMatchesSearch(address: Record<string, any>, searchString?: string): boolean {
    const searchParts = (searchString ?? '').toLowerCase().split(' ').filter(Boolean);
    return searchParts.every(part =>
        Object.keys(address)
            .filter(key => key !== 'label')
            .some(key => {
                const value = address[key];
                return typeof value === 'string' && value.toLowerCase().includes(part);
            })
    );
}
